import { FileData } from 'domains/workspaceDetailDomain';
import api from 'utils/api';
import axios, { CancelToken } from 'axios';

const uploadFileService = {
  putFile: async (file: FormData) => {
    return api.put<FileData>('/api/file', file);
  },
  postFile: async (file: FormData) => {
    return api.post<FileData>('/api/file', file);
  },
  getPresigned: async (fileNameList: string[]) => {
    return api.post<FileData>('/api/file/presigned', fileNameList);
  },

  getSkuPresigned: async (fileNameList: string[]) => {
    return api.post<FileData>('/api/file/sku-presigned', fileNameList);
  },
  uploadFile: async ({
    file,
    cancelTokenObject,
    onUploadProgress,
  }: {
    file: File;
    cancelTokenObject?: { token: CancelToken };
    onUploadProgress?: (param: ProgressEvent) => void;
  }) => {
    try {
      const [s3UrlObject] = await uploadFileService.getPresigned([file.name]);

      await axios.put(s3UrlObject.path, file, {
        headers: {
          'Content-Type': file.type,
          'Content-Disposition': `attachment; filename=${encodeURIComponent(
            file.name
          )}`,
        },
        cancelToken: cancelTokenObject?.token,
        onUploadProgress,
      });
      return s3UrlObject;
    } catch {}
  },

  upSkuImageFile: async ({
    file,
    cancelTokenObject,
    onUploadProgress,
  }: {
    file: File;
    cancelTokenObject?: { token: CancelToken };
    onUploadProgress?: (param: ProgressEvent) => void;
  }) => {
    try {
      const [s3UrlObject] = await uploadFileService.getSkuPresigned([file.name]);

      await axios.put(s3UrlObject.path, file, {
        headers: {
          'Content-Type': file.type,
          'Content-Disposition': `attachment; filename=${encodeURIComponent(
            file.name
          )}`,
        },
        cancelToken: cancelTokenObject?.token,
        onUploadProgress,
      });
      return s3UrlObject;
    } catch {}
  },
};

export default uploadFileService;
